import React from 'react';
import { useFamilyMembers } from '../../hooks/useMembers';
import { initials } from '../../lib/constants';

const ROLE_ICON = { head: '👨', spouse: '👩', child: '👧', member: '👤' };

export default function FamilyChain({ familyId, familyName, currentMemberId }) {
  const members = useFamilyMembers(familyId);
  if (!familyId || !members.length) return null;

  return (
    <div className="family-chain">
      <div className="family-chain-title">🏠 {familyName || 'Family Household'} — {members.length} member{members.length !== 1 ? 's' : ''}</div>
      {members.map(m => (
        <div key={m.id} className="family-member-row">
          <div style={{ width: 28, height: 28, borderRadius: '50%', background: m.status === 'deceased' ? '#ECEFF1' : 'var(--red-light)', color: m.status === 'deceased' ? '#90A4AE' : 'var(--red-dark)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, fontWeight: 700, flexShrink: 0 }}>
            {initials(m)}
          </div>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 13, fontWeight: 700, color: m.status === 'deceased' ? 'var(--text3)' : 'var(--text)', textDecoration: m.status === 'deceased' ? 'line-through' : 'none' }}>
              {m.first_name} {m.last_name}
              {m.id === currentMemberId && <span style={{ fontSize: 10, color: 'var(--blue)', marginLeft: 6 }}>(You)</span>}
            </div>
            <div style={{ fontSize: 11, color: 'var(--text3)' }}>
              {ROLE_ICON[m.family_role] || '👤'} {m.family_role} · {m.membership_type}
              {m.status === 'deceased' && <span style={{ marginLeft: 6, color: '#90A4AE' }}>· Deceased</span>}
            </div>
          </div>
          {m.districts?.name && (
            <span style={{ fontSize: 11, padding: '2px 8px', background: '#EDE7F6', color: '#4527A0', borderRadius: 100, fontWeight: 600 }}>{m.districts.name}</span>
          )}
        </div>
      ))}
    </div>
  );
}
